import axios from 'axios';
import { saveAs } from 'file-saver';
import { last } from 'lodash';

export const saveDataToExcel = async (filePath: string) => {
  const fileUrl = `${process.env.REACT_APP_EXPORTS_ARCHIVE_PATH}${filePath}`;
  try {
    const linkParts = filePath.split('/');
    const fileName: string = last(linkParts) ?? 'Export Comments';

    // Fetch the file
    const response = await axios.get(fileUrl, {
      responseType: 'blob',
    });

    // Use FileSaver to save the file
    saveAs(response.data, fileName);
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
};
